function setArrowOffset(carouselTrack) {
    var trackHeight = carouselTrack.offsetHeight;
    var carousel = carouselTrack.closest('.images-carousel');
    var arrowsNav = carousel.querySelector('.arrows');
    var prevArrow = arrowsNav.querySelector('.prev');
    var nextArrow = arrowsNav.querySelector('.next');

    var arrowHeight = prevArrow.offsetHeight;
    var offset = (trackHeight / 2) - (arrowHeight / 2);

    prevArrow.style.top = offset + 'px';
    nextArrow.style.top = offset + 'px';
}

function getFlexGap(element) {
    const styles = window.getComputedStyle(element);
    var gap = 0;

    if (styles) {
        var rawGap = styles.columnGap || styles.gap;
        if (rawGap === 'normal') {
            gap = 0;
        } else {
            gap = parseFloat(rawGap);
        }
    }
    
    return parseFloat(gap);
}

function enableTransformDrag(element, arrowsNav, carousel) {
    var items = Array.from(element.children);
    var activeIndex = 0;

    var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    var isAnimating = false;
    var isDragging = false;
    var isAutoPlay = element.dataset.autoplay === '1' ? true : false;
    var speed = element.dataset.speed ? element.dataset.speed : 5;
    var hasThumbs = element.getAttribute('data-thumbs');
    var thumbnailControl = null;

    var autoPlayIntervalId = null;
    var startX = 0;
    var startY = 0;

    var currentTranslate = 0;
    var lastTranslate = 0;
    var shiftDirection = null;

    var gap = getFlexGap(element);
    var dragThreshold = 5;

    var prevArrow = arrowsNav.querySelector('.prev');
    var nextArrow = arrowsNav.querySelector('.next');

    function initNextShift(callback) {
        var firstItem = element.children[0];
        var gap = getFlexGap(element);
        var shiftWidth = firstItem.offsetWidth + gap;
    
        element.appendChild(firstItem);

        currentTranslate += shiftWidth;
        element.style.transition = 'none';
        element.style.transform = 'translateX(' + currentTranslate + 'px)';
        void element.offsetWidth;

        items = Array.from(element.children);
        activeIndex--

        if (typeof callback === 'function') {
            callback();
        }
    }

    function initPrevShift() {
        var lastItem = element.children[element.children.length - 1];
        var gap = getFlexGap(element);
        var shiftWidth = lastItem.offsetWidth + gap;
    
        element.insertBefore(lastItem, element.children[0]);

        currentTranslate -= shiftWidth;
        element.style.transition = 'none';
        element.style.transform = 'translateX(' + currentTranslate + 'px)';
        void element.offsetWidth;

        items = Array.from(element.children);
        var maxIndex = items.length - 2;
        activeIndex = Math.min(activeIndex + 1, maxIndex);
    }

    function handlePrevArrowClick() {
        if (isAnimating) return;
        isAnimating = true;
        stopAutoPlay();
        
        activeIndex--;
        shiftDirection = 'prev';
        centerActiveItem(activeIndex);
    }

    function handleNextArrowClick() {
        if (isAnimating) return;
        isAnimating = true;
        stopAutoPlay();

        initNextShift(function () {
            activeIndex++;
            centerActiveItem(activeIndex);
        });
    }

    function getTotalItemWidth(items, gap) {
        var total = 0;
        items.forEach(function (item, i) {
            total += item.offsetWidth;
            if (i > 0) total += gap;
        });
        return total;
    }

    function duplicateToFill() {
        var originalItems = Array.from(items);
        var totalItemsWidth = getTotalItemWidth(items, gap);
        var minFillWidth = totalItemsWidth + getTotalItemWidth([items[0]], gap);

        if (originalItems.length == 1) {
            minFillWidth = element.offsetWidth * 3;
        }
        
        var clones = [];

        originalItems.forEach(function(item, index) {
            item.setAttribute('data-clone-index', index);
        });

        var cloneCounter = originalItems.length;
        
        while (totalItemsWidth < minFillWidth) {

            originalItems.forEach(function (item) {
                var clone = item.cloneNode(true);
                clone.classList.add('dynamic-clone');
                clone.setAttribute('data-id', item.getAttribute('data-id'));
                clone.setAttribute('data-clone-index', cloneCounter++);

                element.appendChild(clone);
                clones.push(clone);

                totalItemsWidth += item.offsetWidth + gap;
            });

        }
    
        items = Array.from(element.children);

        var firstItemId = originalItems[0].getAttribute('data-id');
        var firstItemClones = items.filter(function(el) {
            return el.getAttribute('data-id') === firstItemId;
        });

        if (firstItemClones.length > 1) {
            var secondFirstClone = firstItemClones[1];
            if (originalItems.length == 1) {
                secondFirstClone = firstItemClones[2];
            }
            
            activeIndex = items.indexOf(secondFirstClone);
        }

        if (hasThumbs === 'true') {
            thumbnailControl = generateThumbnails(carousel, originalItems);
        }
        
        waitForImagesToLoad(function() {
            centerActiveItem(activeIndex, true);
            carousel.classList.add('loaded');
        });

        // setTimeout(function() {
        //     centerActiveItem(activeIndex, true);
        // }, 200);

    }

    function waitForImagesToLoad(callback) {
        const images = element.querySelectorAll('img');
        let loaded = 0;
        const total = images.length;
    
        if (total === 0) {
            callback();
            return;
        }
    
        images.forEach( function(img) {
            if (img.complete) {
                loaded++;
                if (loaded === total) callback();
            } else {
                img.addEventListener('load', function() {
                    loaded++;
                    if (loaded === total) callback();
                });
                img.addEventListener('error', function() {
                    loaded++;
                    if (loaded === total) callback();
                });
            }
        });
    }


    

    function centerThumbnail(thumbElement, thumbTrack) {
        const trackRect = thumbTrack.getBoundingClientRect();
        const thumbRect = thumbElement.getBoundingClientRect();
        
        const offset = thumbElement.offsetLeft - (trackRect.width / 2 - thumbRect.width / 2);
        thumbTrack.scrollTo({
            left: offset,
            behavior: 'smooth'
        });
    }

    function generateThumbnails(carousel, originalItems) {
        const thumbs = [];
        const thumbTrack = document.createElement('div');
        thumbTrack.className = 'images-carousel-track images-carousel-thumbs';

        const wrapper = document.createElement('div');
        wrapper.className = 'thumb-track-wrapper';

        thumbTrack.appendChild(wrapper);
        
        var cloneIndex = originalItems.length;
        originalItems.forEach(function (item, index) {

            const clone = item.cloneNode(true);
            const dataId = item.getAttribute('data-id');
        
            clone.classList.add('images-carousel-thumb');
            clone.setAttribute('data-id', dataId);
            clone.setAttribute('data-clone-index', cloneIndex);

            cloneIndex++;
        
            clone.addEventListener('click', function () {
                stopAutoPlay();
            
                const dataId = clone.getAttribute('data-id');
            
                shiftToClosestDataId(dataId, function () {
                    const match = findClosestMatchByDataId(dataId);
                    if (!match) return;
            
                    centerActiveItem(match.index);
            
                    thumbTrack.querySelectorAll('.images-carousel-thumb').forEach(t => t.classList.remove('active'));
                    clone.classList.add('active');
                    centerThumbnail(clone, thumbTrack);
                });
            });
            
            thumbs.push(clone);
            wrapper.appendChild(clone);
        });
    
        carousel.appendChild(thumbTrack);

        const initialItem = items[activeIndex];
        if (initialItem) {
            const activeThumb = thumbs.find(function(t) { 
                return t.getAttribute('data-id') === initialItem.getAttribute('data-id') || t.getAttribute('data-clone-index') === initialItem.getAttribute('data-clone-index')
            });
            
            if (activeThumb) {
                activeThumb.classList.add('active');
                centerThumbnail(activeThumb, thumbTrack);
            }
        }
    
        return {
            thumbTrack,
            thumbs,
            centerActiveThumbnail: function(index) {
                const activeItem = items[index];
                if (!activeItem) return;
            
                const dataId = activeItem.getAttribute('data-id');
                // const cloneIndex = activeItem.getAttribute('data-clone-index');
            
                const activeThumb = thumbs.find(function(t) {
                    return t.getAttribute('data-id') === dataId
                });
            
                if (activeThumb) {
                    thumbs.forEach(function(t) {t.classList.remove('active')});
                    activeThumb.classList.add('active');
                    centerThumbnail(activeThumb, thumbTrack);
                }
            }
        };
    }

    function findClosestMatchByDataId(dataId) {
        let closest = null;
        let minDistance = Infinity;
    
        items.forEach(function(item, index) {
            if (item.getAttribute('data-id') === dataId) {
                const distance = Math.abs(index - activeIndex);
                if (distance < minDistance) {
                    minDistance = distance;
                    closest = { element: item, index };
                }
            }
        });
    
        return closest;
    }

    function shiftToClosestDataId(dataId, callback) {
        const maxAttempts = items.length * 2;
        let attempts = 0;
    
        function doShift() {
            if (attempts++ > maxAttempts) {
                console.warn('Max attempts reached while shifting to data-id:', dataId);
                if (typeof callback === 'function') callback();
                return;
            }
    
            const currentItem = items[activeIndex];
            const currentId = currentItem.getAttribute('data-id');
    
            if (currentId === dataId) {
                if (typeof callback === 'function') callback();
                return;
            }
    
            // Find the closest matching item by data-id
            const match = findClosestMatchByDataId(dataId);
            if (!match) {
                if (typeof callback === 'function') callback();
                return;
            }
    
            if (match.index > activeIndex) {
                initNextShift(() => {
                    activeIndex++;
                    items = Array.from(element.children);
                    doShift();
                });
            } else {
                initPrevShift();
                activeIndex--;
                items = Array.from(element.children);
                setTimeout(doShift, 0);
            }
        }
    
        doShift();
    }



    function centerActiveItem(index, initialLoad) {
        if (!initialLoad) {
            initialLoad = false;
        }
        var containerWidth = element.parentElement.offsetWidth;
        var activeItem = items[index];
        var itemWidth = activeItem.offsetWidth;
        var itemLeft = activeItem.offsetLeft;

        var offset = itemLeft - (containerWidth / 2 - itemWidth / 2);
        if (element.getAttribute('data-align') === "left") {
            offset = itemLeft;
        }

        currentTranslate = -offset;

        element.style.transition = initialLoad ? "" : "transform 0.6s ease-in-out";
        element.style.transform = 'translateX(' + currentTranslate + 'px)';

        setActiveClass(activeItem);

        var hasImagesCarousel = element.closest('.block');
        if (hasImagesCarousel && hasImagesCarousel.classList.contains('images-block')) {

            transformImageCarouselPrevNextImg(items, index);
            setActiveItemInfo(activeItem);
        }

        if (thumbnailControl) {
            thumbnailControl.centerActiveThumbnail(index);
        }
    }

    function transformImageCarouselPrevNextImg(items, index) {
        items.forEach(function(item) {
            var itemImg = item.querySelector('.images-carousel-image');
            if (itemImg) {
                itemImg.style.transformOrigin = 'center center';
            }
        });

        var prevItem = items[index - 1];
        var nextItem = items[index + 1];

        if (prevItem) {
            var prevImg = prevItem.querySelector('.images-carousel-image');
        }
        
        if (nextItem) {
            var nextImg = nextItem.querySelector('.images-carousel-image');
        }

        if (prevImg) {
            prevImg.style.transformOrigin = 'right center';
        }
          
        if (nextImg) {
            nextImg.style.transformOrigin = 'left center';
        }
    }

    function getClientX(e) {
        if (e.touches && e.touches.length > 0) {
            return e.touches[0].clientX;
        } else if (e.changedTouches && e.changedTouches.length > 0) {
            return e.changedTouches[0].clientX;
        } else {
            return e.clientX;
        }
    }

    function handleSnapToItem(e) {
        var dx = getClientX(e) - startX;
        var threshold = 5;
        
        if (Math.abs(dx) > threshold) {
            isAnimating = true;
    
            if (dx < 0) {
                activeIndex++;
                shiftDirection = null;
                initNextShift(function() {
                    centerActiveItem(activeIndex);
                });
            } else {
                activeIndex--;
                shiftDirection = 'prev';
            }

            centerActiveItem(activeIndex);
    
        }
    }

    function setActiveClass(item) {
        Array.from(items).forEach(function(item) {
            item.classList.remove('active');
        });
        item.classList.add('active');
    }

    function setActiveItemInfo(activeItem) {
        var carousel = activeItem.closest('.images-carousel');
        var info = carousel.querySelector('.images-carousel-item-info');
        if(!info) return;
        
        info.classList.remove('active');

        var title = activeItem.getAttribute("data-title") || "";
        var description = activeItem.getAttribute("data-description") || "";
        
        var titleEl = carousel.querySelector('.carousel-title');
        var descEl = carousel.querySelector('.carousel-description');

        if (titleEl) titleEl.textContent = title;
        if (descEl) descEl.textContent = description;
        if (title || description) info.classList.add('active');

    }

    function handleBrowserResize() {
        centerActiveItem(activeIndex);
        setArrowOffset(element);
    }

    function handleItemClick(e) {

        stopAutoPlay();
        isDragging = false;
        hasMoved = false;
        
        var activeItem = getCurrentActiveItem();
        var linkElm = activeItem ? activeItem.querySelector('.custom-link') : null;
        
        if(!linkElm) return;

        var target = linkElm.getAttribute('target');
        var url = linkElm.hasAttribute('href') ? linkElm.getAttribute('href') : '';
        var video = linkElm.dataset.videoModal;
        var modal = linkElm.dataset.promoLink;

        if (video || modal) {
            return linkElm.click();
        }

        if (url) {
            e.stopPropagation();

            if(url.includes('mailto:')) {
                return window.location.href = url;
            }

            var a = document.createElement('a');
            a.href = url;
            a.target = target || '_self';
            a.rel = 'noopener noreferrer';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            a.remove();
        }
    }

    function getCurrentActiveItem() {
        var activeItem = element.querySelector('.images-carousel-item.active');
        return activeItem;
    }

    function onPointerDown(e) {
        if (isAnimating) return;

        isDragging = true;
        hasMoved = false;
        stopAutoPlay();

        startX = e.clientX;
        startY = e.clientY;

        element.style.transition = "";
        // element.setPointerCapture(e.pointerId);
    }

    function onPointerMove(e) {
        if (!isDragging || e.pointerType === 'mouse' && e.buttons !== 1) return;
        
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;

        if (!hasMoved && Math.abs(dy) > Math.abs(dx)) {
            isDragging = false;
            element.releasePointerCapture(e.pointerId);
            return;
        }

        if (!hasMoved && Math.abs(dx) > dragThreshold) {
            hasMoved = true;
            element.classList.add('dragging');

            shiftDirection = dx < 0 ? 'next' : 'prev';
            element.setPointerCapture(e.pointerId);
        }
    
        if (!hasMoved) return;

        e.preventDefault();

        lastTranslate = currentTranslate + dx;

        // var maxTranslate = -(element.scrollWidth - element.offsetWidth);
        // var maxOverflow = itemWidth + itemGap;
        
        // lastTranslate = Math.max(maxTranslate - maxOverflow, Math.min(lastTranslate, maxOverflow));
        element.style.transform = "translateX(" + lastTranslate + "px)";
    }

    function onPointerUp(e) {

        if (!isDragging) return;

        if (!hasMoved) {
            return handleItemClick(e);
        }

        element.releasePointerCapture(e.pointerId);

        currentTranslate = lastTranslate;
        handleSnapToItem(e);

        isDragging = false;
        hasMoved = false;
        element.classList.remove('dragging');
    }

    function onTouchStart(e) {
        if (isAnimating) return;

        isDragging = true;
        hasMoved = false;
        stopAutoPlay();

        var touch = e.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;

        element.style.transition = "";
    }
      
    function onTouchMove(e) {
        if (!isDragging) return;
    
        var touch = e.touches[0];
        var dx = touch.clientX - startX;
        var dy = touch.clientY - startY;
    
        if (!hasMoved) {
            if (Math.abs(dy) > Math.abs(dx)) {
                isDragging = false;
                return;
            }
            if (Math.abs(dx) > dragThreshold) {
                hasMoved = true;
            }
        }
    
        if (hasMoved) {
            e.preventDefault();

            shiftDirection = dx < 0 ? 'next' : 'prev';

            lastTranslate = currentTranslate + dx;
    
            // var maxTranslate = -(element.scrollWidth - element.offsetWidth);
            // var maxOverflow = itemWidth + itemGap;
            
            // lastTranslate = Math.max(maxTranslate - maxOverflow, Math.min(lastTranslate, maxOverflow));
            element.style.transform = "translateX(" + lastTranslate + "px)";
        }
    }
      
    function onTouchEnd(e) {
        if (!isDragging) return;

        if (!hasMoved) {
            return handleItemClick(e);
        }

        currentTranslate = lastTranslate;
        
        handleSnapToItem(e);

        isDragging = false;
        hasMoved = false;
        element.classList.remove('dragging');
    }

    function autoPlay() {
        if (!isAutoPlay) return;
    
        autoPlayIntervalId = setInterval(function () {
            if (!isDragging && !isAnimating) {
                initNextShift(function () {
                    activeIndex++;
                    centerActiveItem(activeIndex);
                });
            }
        }, (speed * 1000));
    }

    function stopAutoPlay() {
        if (autoPlayIntervalId) {
            clearInterval(autoPlayIntervalId);
            autoPlayIntervalId = null;
            isAutoPlay = false;
        }
    }

    function imageClick(e) {
        e.preventDefault();

        var activeItem = getCurrentActiveItem();
        var linkElm = activeItem ? activeItem.querySelector('.custom-link') : null;

        if (!linkElm) return;

        var url = linkElm.getAttribute('href');
        var video = linkElm.dataset.videoModal;
        var modal = linkElm.dataset.promoLink;

        if (!url && !video && !modal) {
            e.stopPropagation();
        }
    }

    function handleSlideTransition(e) {
        if (e.propertyName !== 'transform') return;
    
        if (shiftDirection === 'next') {
            initNextShift();
        } else if (shiftDirection === 'prev') {
            initPrevShift();
        }
        
        shiftDirection = null;
        isAnimating = false;
    }

    function checkForCPanel() {
        try {
            const parentBody = window.parent.document.body;
    
            if (
                parentBody.id === 'cpApp' ||
                parentBody.classList.contains('cp-app')
            ) {
                setTimeout( function() {
                    handleBrowserResize();
                }, 50);
            }
        } catch (e) {
            console.warn('Could not access parent body:', e);
        }
    }

    prevArrow.addEventListener('click', handlePrevArrowClick);
    nextArrow.addEventListener('click', handleNextArrowClick);
    element.addEventListener('click', function(e) {imageClick(e)});

    if (!isTouchDevice) {
        element.addEventListener('pointerdown', function(e) { onPointerDown(e) }, { passive: true });
        element.addEventListener('pointermove', function(e) { onPointerMove(e) }, { passive: false });
        element.addEventListener('pointerup', function(e) { onPointerUp(e) });
    } else {
        element.addEventListener('touchstart', function(e) { onTouchStart(e) }, { passive: true });
        element.addEventListener('touchmove', function(e) { onTouchMove(e) }, { passive: false });
        element.addEventListener('touchend', function(e) { onTouchEnd(e) });
    }

    element.addEventListener('transitionend', function (e) { handleSlideTransition(e) });
    element.addEventListener('webkitTransitionEnd', function (e) { handleSlideTransition(e) });
    window.addEventListener('resize', handleBrowserResize);

    document.addEventListener('visibilitychange', function () {
        if (!document.hidden) {
            setTimeout( function() {
                handleBrowserResize();
            }, 50);
        }
    });
    
    duplicateToFill();
    autoPlay();
    checkForCPanel();
    
}
 
var init = function () {

    window.onload = function () {
    
        var carousels = document.querySelectorAll('.images-carousel');

        carousels.forEach(function(carousel) {

            var track = carousel.querySelector('.images-carousel-track');
            var arrows = carousel.querySelector('.arrows');

            if (track && arrows) {
                setArrowOffset(track);
                enableTransformDrag(track, arrows, carousel);
            }

        });
    }

};

module.exports = {
  init: init
};